import React from 'react';
import styled from 'styled-components';

interface NameProps {
  className?: string;
  name: string;
}

class Name extends React.PureComponent<NameProps> {
  render() {
    const { name, ...props } = this.props;

    return (
      <StyledName title={name} {...props}>
        {name}
      </StyledName>
    );
  }
}

const StyledName = styled.div`
  font-weight: 700;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export default Name;
